module.exports = __webpack_public_path__ + "img/stickers-avis-impots-x3.cec37a47.jpg";